import styled from "styled-components";

export const TableWrapper = styled.div`
  margin: 0 50px;
  margin-top: 20px;
  @media(max-width: 576px){
    margin: 0 20px;
  }
`;
